import React from 'react'

import styled from '@emotion/styled'
import Image from '../../atoms/image';
import { grayBorder } from '../../../_style';

const Container = styled.div`
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid ${grayBorder};
`

export default class DetailMainHead extends React.Component {
  render() {
    return(
      <Container>
        {this.props.children}
      </Container>
    )
  }
}
